import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Learn from "@/pages/Learn";
import Help from "@/pages/Help";
import About from "@/pages/About";
import Dashboard from "@/pages/dashboard/Dashboard";
import Analytics from "@/pages/dashboard/Analytics";
import Activity from "@/pages/dashboard/Activity";
import Organizations from "@/pages/dashboard/Organizations";
import Settings from "@/pages/dashboard/Settings";
import Calendar from "@/pages/dashboard/Calendar";
import Reports from "@/pages/dashboard/Reports";
import Library from "@/pages/dashboard/Library";
import Threats from "@/pages/dashboard/Threats";
import HelpDashboard from "@/pages/dashboard/Help";
import KnowledgeBase from "@/pages/dashboard/KnowledgeBase";
import Support from "@/pages/dashboard/Support";

function AppRouter() {
  return (
    <Routes>
      <Route 
        path="/" 
        element={
          <ErrorBoundary>
            <Landing />
          </ErrorBoundary>
        } 
      />
      <Route 
        path="/auth" 
        element={
          <ErrorBoundary>
            <Auth />
          </ErrorBoundary>
        } 
      />
      <Route 
        path="/learn" 
        element={
          <ErrorBoundary>
            <Learn />
          </ErrorBoundary>
        } 
      />
      <Route 
        path="/help" 
        element={
          <ErrorBoundary>
            <Help />
          </ErrorBoundary>
        } 
      />
      <Route 
        path="/about" 
        element={
          <ErrorBoundary>
            <About />
          </ErrorBoundary>
        } 
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <Dashboard />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/analytics"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <Analytics />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/activity"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <Activity />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/organizations"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <Organizations />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/settings"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <Settings />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/calendar"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <Calendar />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/reports"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <Reports />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/library"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <Library />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/threats"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <Threats />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/help"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <HelpDashboard />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/kb"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <KnowledgeBase />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/support"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <Support />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default AppRouter;